import { InputAdornment, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import React from 'react';

type PropsType = TextFieldProps & {};

export const PercentageField = (props: PropsType) => {
  const { InputProps, ...restProps } = props;

  const fieldProps: TextFieldProps = {
    InputProps: {
      inputMode: 'decimal',
      inputProps: {
        style: {
          textAlign: 'right',
        },
      },
      endAdornment: <InputAdornment position="end">%</InputAdornment>,
      ...InputProps,
    },
    ...restProps,
  };

  return <TextField {...fieldProps} />;
};
